/* eslint-disable */
import {DeviceState} from './state';
import {getStoreAccessors} from 'typesafe-vuex';
import {State} from '../state';
import {IDevice, IDeviceNew, IDeviceSpacs } from '@/interfaces';

export const mutations = {
    setDevices(state: DeviceState, payload: IDevice[]) {
        state.deviceList = payload;
    },
    setDeviceSpecs(state: DeviceState, payload: IDevice[]) {
        state.deviceSpecs = payload;
    },
     setGetDeviceSpecsNew(state: DeviceState, payload: IDeviceNew) {
        state.deviceSpecsNew = payload;
    },
    setDeviceSpecsList(state: DeviceState, payload: IDeviceSpacs[]) {
        state.deviceSpecsList = payload;
    },
    setDevice(state: DeviceState, payload: IDevice[]) {
        state.deviceList = payload;
    },
    setCreateDeviceSpecsList(state: DeviceState, payload: IDeviceSpacs[]) {
        state.deviceSpecsList = payload;
    },
    updateDevice(state: DeviceState, payload: IDevice[]) {
        // const goal_device = state.deviceSpecs.filter((device: IDevice) =>  device.id === payload.id)[0]
        // const deviceList = state.deviceSpecs.filter((device: IDevice) =>  device.id !== payload.id);
        // goal_device.remark = payload.remark
        // goal_device.status = payload.status
        // deviceList.unshift(goal_device);
        state.deviceSpecs = payload;

        // const index: number =  state.deviceSpecs.indexOf(goal_device)
        // const deviceList = state.deviceSpecs;
        // goal_device.remark = payload.remark
        // deviceList.splice(index, 1, goal_device)
        // state.deviceSpecs = deviceList;
    },
    updateSystem(state: DeviceState, payload: IDeviceSpacs[]) {
        // const goal_device = state.deviceSpecs.filter((device: IDevice) =>  device.id === payload.id)[0]
        // const deviceList = state.deviceSpecs.filter((device: IDevice) =>  device.id !== payload.id);
        // goal_device.remark = payload.remark
        // goal_device.status = payload.status
        // deviceList.unshift(goal_device);
        state.deviceSpecs = payload;

        // const index: number =  state.deviceSpecs.indexOf(goal_device)
        // const deviceList = state.deviceSpecs;
        // goal_device.remark = payload.remark
        // deviceList.splice(index, 1, goal_device)
        // state.deviceSpecs = deviceList;
    },
    deleteDevice(state: DeviceState, payload: number) {
        state.deviceSpecs = state.deviceSpecs.filter((device: IDevice) =>  device.id !== payload);
    },
};

const { commit } = getStoreAccessors<DeviceState, State>('');
export const commitSetDevices = commit(mutations.setDevices);
export const commitSetDeviceSpecs = commit(mutations.setDeviceSpecs);
export const commitGetDeviceSpecsNew = commit(mutations.setGetDeviceSpecsNew);
export const commitSetDeviceSpecsList = commit(mutations.setDeviceSpecsList);
export const commitSetDevice = commit(mutations.setDevice)
export const commitCreateDeviceSpecsList = commit(mutations.setCreateDeviceSpecsList)
export const commitUpdateDevice = commit(mutations.updateDevice)
export const commitUpdateSystem = commit(mutations.updateSystem)
export const commitDeleteDevice = commit(mutations.deleteDevice)




